<template>
    <div id="cell">
        <div class="title" :class="{active:titleShow}">
            <div class="divide-spot"></div>
            <div class="title-zh">{{$t('navBar.exhibition')}}</div>
            <div class="title-en">#CASE PRESENTATION#</div>
        </div>
        <div class="cube">
            <div  class="cube-cell" @click="toListPage(list.key)" :key="list.key" v-for="list in cubeLists"
                 @mouseenter="list.cloakShow=true"
                 @mouseleave="list.cloakShow=false"
            >
                <img  onclick="return false" :src="list.img" alt="">
                <transition name="cube-cloak">
                    <div class="cube-cell-cloak" v-show="list.cloakShow">
                        <transition name="cloak-img">
                            <img onclick="return false" v-show="list.cloakShow" class="icon" :src="list.cloakImg" alt="">
                        </transition>
                        <div class="text">{{list.text}}</div>
                    </div>
                </transition>
                <div class="tag" :class="{'repair-tag':list.tagName==='生活服务'||list.tagName==='智慧社区'}">
                    <img onclick="return false" :src="list.tagImg" alt="">
                    <p>{{list.tagName}}</p>
                </div>
            </div>
            <div class="cube-cell" key="10"
            >
                <transition name="cube-cloak">
                    <div class="cube-cell-cloak">
                        <p class="cube-cell-cloak-join">期待您的加入</p>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import {isPC} from '../../utils/methods'
   // import shuffle from '../../utils/shuffle'

    export default {
        name: "cell",
        data() {
            return {
                titleShow: false,
                cubeLists: [
                    {
                        key: 'xianZhi',
                        img: require('../../assets/cell/xianzhi.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/xianzhi-icon.png'),
                        tagImg: require('../../assets/cell/icon-LifeService.png'),
                        tagName: '生活服务',
                        text: '闲之'
                    },
                    {
                        key: 'kaKa',
                        img: require('../../assets/cell/kaka.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/kaka-icon.png'),
                        tagImg: require('../../assets/cell/icon-Onlineretailers.png'),
                        tagName: '电商',
                        text: '咔咔城堡'
                    },
                    {
                        key: 'zgyh',
                        img: require('../../assets/cell/zgyh.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/zgyh-icon.png'),
                        tagImg: require('../../assets/cell/icon-Finance.png'),
                        tagName: '金融',
                        text: '企业客户管理系统'
                    },
                    {
                        key: 'linYun',
                        img: require('../../assets/cell/linyun.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/linyun-iocn.png'),
                        tagImg: require('../../assets/cell/icon-Community.png'),
                        tagName: '智慧社区',
                        text: '邻云管家'
                    },
                    {
                        key: 'yycf',
                        img: require('../../assets/cell/yycf.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/yiyangchafu-icon.png'),
                        tagImg: require('../../assets/cell/icon-LifeService.png'),
                        tagName: '生活服务',
                        text: '溢阳茶府'
                    },
                    {
                        key: 'cyb',
                        img: require('../../assets/cell/cyb.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/cheyibao-icon.png'),
                        tagImg: require('../../assets/cell/icon-Insurance.png'),
                        tagName: '保险',
                        text: '车衣宝'
                    },
                    {
                        key: 'lePao',
                        img: require('../../assets/cell/lepao.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/lepao-icon.png'),
                        tagImg: require('../../assets/cell/icon-LifeService.png'),
                        tagName: '生活服务',
                        text: '乐跑'
                    },
                    {
                        key: 'vitte',
                        img: require('../../assets/cell/vitte.png'),
                        cloakShow: false,
                        cloakImg: require('../../assets/cell/vitte-icon.png'),
                        tagImg: require('../../assets/cell/icon-Trip.png'),
                        tagName: '出行',
                        text: 'VITTE打车'
                    },
                ]
            }
        },
        mounted() {
            this.letTitleShow()
            if (!isPC()) {
                this.letAllCloakShow()
            }
        },
        methods: {
            letTitleShow() {
                setTimeout(() => {
                    this.titleShow = true
                }, 200)
            },
            letAllCloakShow() {
                window.requestAnimationFrame(() => this.cubeLists.forEach(item => item.cloakShow = true));
            },
            toListPage(name) {
                if (typeof name === 'number') return
                this.$router.push({path: `/${name}`})
            }
        }
    }
</script>

<style scoped lang="scss" src="./cell.scss"></style>
